var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "head", class: _vm.isSearch && "isSearch" },
    [
      _c("img", {
        staticClass: "wapmeau",
        staticStyle: { cursor: "pointer" },
        attrs: { src: require("../../assets/img/meau.png") },
        on: { click: _vm.wapShowMeau }
      }),
      _vm._v(" "),
      _c("img", {
        staticClass: "logo",
        attrs: {
          src:
            "https://master-shopvidi.s3.amazonaws.com/index_images/shop_logo%402x.png"
        },
        on: {
          click: function($event) {
            return _vm.$router.push("/")
          }
        }
      }),
      _vm._v(" "),
      _c("img", {
        ref: "searchBtn",
        staticClass: "search-icon search-icon-visitor",
        style: _vm.login ? "right:120px" : "right:130px",
        attrs: {
          src: require("../../assets/search-icon.png"),
          width: "20px",
          height: "20px"
        },
        on: {
          click: function($event) {
            return _vm.$router.push("/search")
          }
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        { ref: "searchBox", staticClass: "search-box" },
        [
          _c("el-input", {
            attrs: {
              "prefix-icon": "el-icon-search",
              placeholder:
                "Search Product Name/Collections/Category/Brands/Sku",
              clearable: ""
            },
            on: {
              blur: _vm.blurHandle,
              focus: _vm.focusHandle,
              input: _vm.queryBrand
            },
            model: {
              value: _vm.valueData.value,
              callback: function($$v) {
                _vm.$set(_vm.valueData, "value", $$v)
              },
              expression: "valueData.value"
            }
          }),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "search-btn",
              attrs: { type: "primary" },
              on: { click: _vm.onSubmit },
              nativeOn: {
                keyup: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.enterSearch()
                }
              }
            },
            [_vm._v("Search")]
          ),
          _vm._v(" "),
          _vm.isShow1V1Checkbox
            ? _c(
                "el-checkbox",
                {
                  on: { change: _vm.change1v1 },
                  model: {
                    value: _vm.checked1v1,
                    callback: function($$v) {
                      _vm.checked1v1 = $$v
                    },
                    expression: "checked1v1"
                  }
                },
                [_vm._v("是否显示1v1视频")]
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.brandList.length > 0
        ? _c(
            "div",
            { staticClass: "brand-main" },
            [
              _c("div", { staticClass: "brands-title" }, [_vm._v("Brands")]),
              _vm._v(" "),
              _vm._l(_vm.brandList, function(item, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    ref: "select-" + index,
                    refInFor: true,
                    staticClass: "brand-row",
                    on: {
                      click: function($event) {
                        return _vm.gotoBrand(item)
                      },
                      mousemove: function($event) {
                        return _vm.changeColor($event)
                      },
                      mouseleave: function($event) {
                        return _vm.resetColor($event)
                      }
                    }
                  },
                  [
                    _c("img", {
                      staticStyle: {
                        height: "50px",
                        width: "50px",
                        border: "1px solid #E1E1E1",
                        "border-radius": "50%"
                      },
                      attrs: { src: item.brandLogoUrl }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "brand-name" }, [
                      _vm._v(_vm._s(item.brandName))
                    ]),
                    _vm._v(" "),
                    item.isVilocal
                      ? _c("div", { staticClass: "brand-vilocal" }, [
                          _vm._v("ViLocal")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    item.salesManager
                      ? _c(
                          "el-tag",
                          {
                            staticStyle: { "margin-left": "10px" },
                            attrs: { type: "danger" }
                          },
                          [_vm._v("Top Brand")]
                        )
                      : _vm._e()
                  ],
                  1
                )
              })
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.login
        ? _c("div", { staticClass: "login-btns" }, [
            _c(
              "div",
              {
                staticClass: "content1-right-personimg-user hide shopping-cart",
                on: { click: _vm.gotoShoppingCart }
              },
              [
                _c("div", { staticClass: "shopping-cart-info hide" }, [
                  _vm._v(
                    _vm._s(
                      _vm.shoppingCartValue == 0
                        ? "0 Item"
                        : _vm.shoppingCartValue + " Items"
                    )
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "shopping-cart-info-mobile" }, [
                  _vm._v(
                    _vm._s(
                      _vm.shoppingCartValue == 0 ? 0 : _vm.shoppingCartValue
                    )
                  )
                ]),
                _vm._v(" "),
                _c(
                  "el-badge",
                  {
                    staticClass: "item",
                    attrs: { "is-dot": !_vm.shoppingCartValue == 0 }
                  },
                  [
                    _c("div", { staticClass: "cart" }, [
                      _c("img", {
                        attrs: {
                          height: "25px",
                          width: "25px",
                          src: require("../../assets/shopping-icon.png")
                        }
                      })
                    ])
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "content1-right-personimg-user hide my-icon",
                on: { mouseover: _vm.showMenu, mouseleave: _vm.hideMenu }
              },
              [
                _c("img", {
                  staticClass: "my-img",
                  attrs: {
                    height: "25px",
                    width: "25px",
                    src: require("../../assets/my.png")
                  }
                })
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "content1-right-personimg-user content1-right-coupon",
                on: {
                  click: function($event) {
                    return _vm.$router.push({ path: "/coupon" })
                  }
                }
              },
              [
                _vm.myCouponCount
                  ? _c("div", { staticClass: "count_num" }, [
                      _vm._v(_vm._s(_vm.myCouponCount))
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("img", {
                  attrs: {
                    height: "25px",
                    width: "25px",
                    src: require("../../assets/shopping-coupon.png")
                  }
                })
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "search-icon content1-right-personimg-user" },
              [
                _c("img", {
                  style: _vm.login ? "right:120px" : "right:130px",
                  attrs: {
                    src: require("../../assets/search-icon.png"),
                    width: "20px",
                    height: "20px"
                  },
                  on: {
                    click: function($event) {
                      return _vm.$router.push("/search")
                    }
                  }
                })
              ]
            )
          ])
        : _c("div", { staticClass: "login-btns visitor" }, [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "right-content-reg",
                on: {
                  click: function($event) {
                    return _vm.loginHandle("register")
                  }
                }
              },
              [
                _c(
                  "span",
                  {
                    staticClass: "content1-btn",
                    staticStyle: { color: "#ffffff" }
                  },
                  [_vm._v("Sign up")]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "right-content-reg show",
                on: {
                  click: function($event) {
                    return _vm.loginHandle("register")
                  }
                }
              },
              [
                _c(
                  "span",
                  {
                    staticClass: "content1-btn",
                    staticStyle: { color: "#ffffff" }
                  },
                  [_vm._v("Sign up")]
                )
              ]
            ),
            _vm._v(" "),
            _vm.isPre
              ? _c(
                  "div",
                  {
                    staticClass: "right-content-reg",
                    on: { click: _vm.showTempLogin }
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "content1-btn",
                        staticStyle: { color: "#ffffff" }
                      },
                      [_vm._v("模拟登录")]
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isPre
              ? _c(
                  "div",
                  {
                    staticClass: "right-content-reg",
                    on: { click: _vm.showSdrLogin }
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "content1-btn",
                        staticStyle: { color: "#ffffff" }
                      },
                      [_vm._v("SDR/SR")]
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "right-content-login",
                on: {
                  click: function($event) {
                    return _vm.loginHandle("login")
                  }
                }
              },
              [_c("span", { staticClass: "content1-btn" }, [_vm._v("Login")])]
            )
          ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "meau",
          style: _vm.showMeau ? "height:auto" : "height:0",
          on: { mouseover: _vm.showMenu, mouseleave: _vm.hideMenu }
        },
        [
          _c(
            "div",
            { staticClass: "meau-body" },
            [
              _c("div", { staticClass: "meau-top" }, [
                _c("div", { staticStyle: { "text-align": "center" } }, [
                  _vm._v("Hello," + _vm._s(_vm.realname))
                ])
              ]),
              _vm._v(" "),
              _vm.isUseNt
                ? [
                    _vm.pcPayMenthod.pcNetQualificationStatus == "completed" ||
                    _vm.pcPayMenthod.pcNetQualificationStatus == "approved"
                      ? [
                          _c("div", { staticClass: "apply-border" }, [
                            _c(
                              "div",
                              { staticClass: "info" },
                              [
                                !_vm.netPayable
                                  ? _c("div", { staticClass: "net-term" }, [
                                      _c(
                                        "p",
                                        {
                                          on: {
                                            click: function($event) {
                                              return _vm.$router.push({
                                                name: "profile"
                                              })
                                            }
                                          }
                                        },
                                        [_vm._v("Open net term payment")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "p",
                                        {
                                          staticStyle: { "font-size": "12px" }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.tooltipText.split(",")[0]
                                            )
                                          )
                                        ]
                                      )
                                    ])
                                  : [
                                      _vm._m(1),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "money_box" }, [
                                        _c("div", [
                                          _vm.pcPayMenthod.creditLimit
                                            ? _c(
                                                "div",
                                                { staticClass: "money" },
                                                [
                                                  _c("div", [
                                                    _vm._v(
                                                      "$" +
                                                        _vm._s(
                                                          _vm._f("numFormat")(
                                                            _vm.pcPayMenthod
                                                              .totalCreditLimit
                                                          )
                                                        )
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  !_vm.pcPayMenthod
                                                    .exclusiveAvailableLimit
                                                    ? [
                                                        _vm.increaseStatus
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "shoping_button",
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.$router.push(
                                                                      {
                                                                        name:
                                                                          "apply"
                                                                      }
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                            Increase My Limit\n                          "
                                                                )
                                                              ]
                                                            )
                                                          : _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "shoping_button"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "Review increase limit"
                                                                )
                                                              ]
                                                            )
                                                      ]
                                                    : _vm._e()
                                                ],
                                                2
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.pcPayMenthod.creditLimit
                                            ? _c(
                                                "div",
                                                { staticClass: "info-desc" },
                                                [_vm._v("Credits available")]
                                              )
                                            : _vm._e()
                                        ]),
                                        _vm._v(" "),
                                        _vm.pcPayMenthod.exclusiveAvailableLimit
                                          ? _c("div", {
                                              staticClass: "line_between"
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.pcPayMenthod.exclusiveAvailableLimit
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "money_box_right"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "money" },
                                                  [
                                                    _c("div", [
                                                      _vm._v(
                                                        "$" +
                                                          _vm._s(
                                                            _vm.pcPayMenthod
                                                              .exclusiveAvailableLimit
                                                          )
                                                      )
                                                    ])
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  { staticClass: "info-desc" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.pcPayMenthod
                                                          .exclusiveBrandName
                                                      ) + " Credits"
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]),
                                      _vm._v(" "),
                                      _vm.pcPayMenthod.exclusiveAvailableLimit
                                        ? [
                                            _vm.increaseStatus
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "shoping_button",
                                                    staticStyle: {
                                                      "margin-top": "15px",
                                                      "margin-left": "0px"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.$router.push(
                                                          { name: "apply" }
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Increase My Limit\n                    "
                                                    )
                                                  ]
                                                )
                                              : _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "shoping_button",
                                                    staticStyle: {
                                                      "margin-top": "15px",
                                                      "margin-left": "0px"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Review increase\n                      limit\n                    "
                                                    )
                                                  ]
                                                )
                                          ]
                                        : _vm._e()
                                    ]
                              ],
                              2
                            )
                          ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.pcPayMenthod.pcNetQualificationStatus === "inReview" ||
                    _vm.pcPayMenthod.pcNetQualificationStatus === "frozen"
                      ? [
                          _c("div", { staticClass: "apply-border" }, [
                            _c(
                              "div",
                              { staticClass: "info" },
                              [
                                !_vm.netPayable
                                  ? _c("div", { staticClass: "net-term" }, [
                                      _c(
                                        "p",
                                        {
                                          on: {
                                            click: function($event) {
                                              return _vm.$router.push({
                                                name: "profile"
                                              })
                                            }
                                          }
                                        },
                                        [_vm._v("Open net term payment")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "p",
                                        {
                                          staticStyle: { "font-size": "12px" }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.tooltipText.split(",")[0]
                                            )
                                          )
                                        ]
                                      )
                                    ])
                                  : [
                                      _c("div", { staticClass: "info-name" }, [
                                        _c("span", [_vm._v("Net terms")]),
                                        _vm._v(" "),
                                        _vm.pcPayMenthod
                                          .pcNetQualificationStatus !==
                                        "inReview"
                                          ? _c(
                                              "span",
                                              {
                                                class:
                                                  _vm.pcPayMenthod
                                                    .pcNetQualificationStatus ===
                                                  "inReview"
                                                    ? "status color-gray"
                                                    : "status color-blue"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("toFirstUpper")(
                                                      _vm.pcPayMenthod
                                                        .pcNetQualificationStatus
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]),
                                      _vm._v(" "),
                                      _vm.pcPayMenthod
                                        .pcNetQualificationStatus === "frozen"
                                        ? _c(
                                            "div",
                                            { staticClass: "net-term" },
                                            [
                                              _c(
                                                "p",
                                                {
                                                  staticStyle: {
                                                    cursor: "none",
                                                    "text-decoration": "none"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "Contact Customer Service"
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "p",
                                                {
                                                  staticStyle: {
                                                    "font-size": "12px"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "To unlock the net term status"
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        : _c(
                                            "div",
                                            { staticClass: "money_box" },
                                            [
                                              _c("div", [
                                                _c(
                                                  "div",
                                                  { staticClass: "money" },
                                                  [
                                                    _c("div", [
                                                      _vm._v(
                                                        "$" +
                                                          _vm._s(
                                                            _vm._f("numFormat")(
                                                              _vm.pcPayMenthod
                                                                .totalCreditLimit
                                                            )
                                                          )
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    !_vm.pcPayMenthod
                                                      .exclusiveAvailableLimit
                                                      ? [
                                                          _vm.increaseStatus
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "shoping_button",
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.$router.push(
                                                                        {
                                                                          name:
                                                                            "apply"
                                                                        }
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                            Increase\n                            My Limit\n                          "
                                                                  )
                                                                ]
                                                              )
                                                            : _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "shoping_button"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "Review increase limit"
                                                                  )
                                                                ]
                                                              )
                                                        ]
                                                      : _vm._e()
                                                  ],
                                                  2
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  { staticClass: "info-desc" },
                                                  [_vm._v("Credits available")]
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _vm.pcPayMenthod
                                                .exclusiveAvailableLimit
                                                ? _c("div", {
                                                    staticClass: "line_between"
                                                  })
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.pcPayMenthod
                                                .exclusiveAvailableLimit
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "money_box_right"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass: "money"
                                                        },
                                                        [
                                                          _c("div", [
                                                            _vm._v(
                                                              "$" +
                                                                _vm._s(
                                                                  _vm
                                                                    .pcPayMenthod
                                                                    .exclusiveAvailableLimit
                                                                )
                                                            )
                                                          ])
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "info-desc"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.pcPayMenthod
                                                                .exclusiveBrandName
                                                            ) + " Credits"
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          ),
                                      _vm._v(" "),
                                      _vm.pcPayMenthod.exclusiveAvailableLimit
                                        ? [
                                            _vm.increaseStatus
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "shoping_button",
                                                    staticStyle: {
                                                      "margin-top": "15px",
                                                      "margin-left": "0px"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.$router.push(
                                                          { name: "apply" }
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Increase My Limit\n                    "
                                                    )
                                                  ]
                                                )
                                              : _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "shoping_button",
                                                    staticStyle: {
                                                      "margin-top": "15px",
                                                      "margin-left": "0px"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Review increase limit\n                    "
                                                    )
                                                  ]
                                                )
                                          ]
                                        : _vm._e()
                                    ]
                              ],
                              2
                            )
                          ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.pcPayMenthod.pcNetQualificationStatus == "declined" ||
                    _vm.pcPayMenthod.pcNetQualificationStatus == "disabled"
                      ? [
                          _c("div", { staticClass: "apply-border" }, [
                            _c("div", { staticClass: "info" }, [
                              !_vm.netPayable
                                ? _c("div", { staticClass: "net-term" }, [
                                    _c(
                                      "p",
                                      {
                                        on: {
                                          click: function($event) {
                                            return _vm.$router.push({
                                              name: "profile"
                                            })
                                          }
                                        }
                                      },
                                      [_vm._v("Open net term payment")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "p",
                                      { staticStyle: { "font-size": "12px" } },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.tooltipText.split(",")[0])
                                        )
                                      ]
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.netPayable
                                ? _c("div", { staticClass: "info-name" }, [
                                    _c("span", [_vm._v("Net terms")]),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        class:
                                          _vm.pcPayMenthod
                                            .pcNetQualificationStatus ==
                                          "declined"
                                            ? "status color-red"
                                            : "status color-brown"
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("toFirstUpper")(
                                              _vm.pcPayMenthod
                                                .pcNetQualificationStatus
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.netPayable
                                ? _c("div", { staticClass: "net-term" }, [
                                    _c(
                                      "p",
                                      {
                                        staticStyle: {
                                          cursor: "none",
                                          "text-decoration": "none"
                                        }
                                      },
                                      [_vm._v("Contact Customer Service")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "p",
                                      { staticStyle: { "font-size": "12px" } },
                                      [_vm._v("To unlock the net term status")]
                                    )
                                  ])
                                : _vm._e()
                            ])
                          ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.pcPayMenthod.pcNetQualificationStatus
                      ? [
                          _c("div", { staticClass: "apply-border" }, [
                            _c(
                              "div",
                              { staticClass: "info" },
                              [
                                _vm.netPayable
                                  ? _c(
                                      "div",
                                      { staticClass: "info-name" },
                                      [
                                        _c("span", [_vm._v("Net terms")]),
                                        _vm._v(" "),
                                        _c(
                                          "el-tooltip",
                                          {
                                            staticClass: "item",
                                            attrs: {
                                              effect: "dark",
                                              content: _vm.tooltipText,
                                              placement: "top"
                                            }
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "el-icon-warning-outline",
                                              staticStyle: {
                                                "font-size": "20px"
                                              }
                                            })
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.netPayable
                                  ? _c("div", { staticClass: "net-term" }, [
                                      _c(
                                        "p",
                                        {
                                          on: {
                                            click: function($event) {
                                              return _vm.$router.push({
                                                name: "profile"
                                              })
                                            }
                                          }
                                        },
                                        [_vm._v("Open net term payment")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "p",
                                        {
                                          staticStyle: { "font-size": "12px" }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.tooltipText.split(",")[0]
                                            )
                                          )
                                        ]
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.netPayable
                                  ? _c("div", { staticClass: "money_box" }, [
                                      _c("div", [
                                        _c(
                                          "div",
                                          { staticClass: "money" },
                                          [
                                            _c("div", [
                                              _vm._v(
                                                "$" +
                                                  _vm._s(
                                                    _vm._f("numFormat")(
                                                      _vm.pcPayMenthod
                                                        .totalCreditLimit
                                                    )
                                                  )
                                              )
                                            ]),
                                            _vm._v(" "),
                                            !_vm.pcPayMenthod
                                              .exclusiveAvailableLimit
                                              ? [
                                                  _vm.increaseStatus
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "shoping_button",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.$router.push(
                                                                {
                                                                  name: "apply"
                                                                }
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Increase\n                          My Limit\n                        "
                                                          )
                                                        ]
                                                      )
                                                    : _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "shoping_button"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Review increase limit"
                                                          )
                                                        ]
                                                      )
                                                ]
                                              : _vm._e()
                                          ],
                                          2
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "info-desc" },
                                          [_vm._v("Credits available")]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _vm.pcPayMenthod.exclusiveAvailableLimit
                                        ? _c("div", {
                                            staticClass: "line_between"
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.pcPayMenthod.exclusiveAvailableLimit
                                        ? _c(
                                            "div",
                                            { staticClass: "money_box_right" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "money" },
                                                [
                                                  _c("div", [
                                                    _vm._v(
                                                      "$" +
                                                        _vm._s(
                                                          _vm.pcPayMenthod
                                                            .exclusiveAvailableLimit
                                                        )
                                                    )
                                                  ])
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "info-desc" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.pcPayMenthod
                                                        .exclusiveBrandName
                                                    ) + " Credits"
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.pcPayMenthod.exclusiveAvailableLimit &&
                                _vm.netPayable
                                  ? [
                                      _vm.increaseStatus
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "shoping_button",
                                              staticStyle: {
                                                "margin-top": "15px",
                                                "margin-left": "0px"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.$router.push({
                                                    name: "apply"
                                                  })
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "Increase My Limit\n                  "
                                              )
                                            ]
                                          )
                                        : _c(
                                            "div",
                                            {
                                              staticClass: "shoping_button",
                                              staticStyle: {
                                                "margin-top": "15px",
                                                "margin-left": "0px"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "Review increase limit\n                  "
                                              )
                                            ]
                                          )
                                    ]
                                  : _vm._e()
                              ],
                              2
                            )
                          ])
                        ]
                      : _vm._e()
                  ]
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "meau-list" },
                _vm._l(_vm.menuList, function(item, id) {
                  return !item.hidden
                    ? _c(
                        "p",
                        {
                          key: id,
                          on: {
                            click: function($event) {
                              return _vm.gotoPlatform(item)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(item.name) +
                              "\n          "
                          )
                        ]
                      )
                    : _vm._e()
                }),
                0
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "meau-down", on: { click: _vm.signOut } },
                [_vm._v("Sign Out")]
              )
            ],
            2
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "wap",
          attrs: {
            visible: _vm.loginVisible,
            "destroy-on-close": true,
            fullscreen: _vm.showH5App ? true : false,
            width: "880px",
            "append-to-body": true,
            "close-on-click-modal": false,
            "before-close": _vm.handleClose,
            "lock-scroll": true
          },
          on: {
            "update:visible": function($event) {
              _vm.loginVisible = $event
            }
          }
        },
        [
          _c("Login", {
            key: _vm.loginType,
            attrs: { type: _vm.loginType },
            on: { submitHandle: _vm.submitHandle }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "wap",
          attrs: {
            visible: _vm.showTempLoginDialog,
            "destroy-on-close": true,
            width: "880px",
            "append-to-body": true
          },
          on: {
            "update:visible": function($event) {
              _vm.showTempLoginDialog = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticStyle: { width: "90%", padding: "20px" } },
            [
              _c("el-input", {
                staticStyle: { margin: "30px 0px" },
                attrs: {
                  placeholder: "email",
                  "auto-complete": "new-password"
                },
                model: {
                  value: _vm.email,
                  callback: function($$v) {
                    _vm.email = $$v
                  },
                  expression: "email"
                }
              }),
              _vm._v(" "),
              _c(
                "el-input",
                {
                  staticStyle: { "margin-bottom": "20px" },
                  attrs: {
                    placeholder: "password",
                    "auto-complete": "new-password",
                    type: _vm.passw
                  },
                  model: {
                    value: _vm.password,
                    callback: function($$v) {
                      _vm.password = $$v
                    },
                    expression: "password"
                  }
                },
                [
                  _c(
                    "i",
                    {
                      attrs: { slot: "suffix" },
                      on: { click: _vm.showPass },
                      slot: "suffix"
                    },
                    [
                      _vm.passw == "password"
                        ? _c("img", {
                            staticStyle: { width: "25px", height: "25px" },
                            attrs: {
                              src: require("../../assets/img/icon-hide.png"),
                              alt: ""
                            }
                          })
                        : _c("img", {
                            staticStyle: { width: "25px", height: "25px" },
                            attrs: {
                              src: require("../../assets/img/icon-show.png"),
                              alt: ""
                            }
                          })
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c("el-button", { on: { click: _vm.tempLogin } }, [
                _vm._v("Login")
              ])
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c("SdrLogin", {
        attrs: { showSdrLoginDialog: _vm.showSdrLoginDialog },
        on: {
          sdrLogin: _vm.sdrLogin,
          closeSdrLoginDialog: _vm.closeSdrLoginDialog
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content1-right-personimg hide my" }, [
      _c("img", {
        attrs: {
          height: "17px",
          width: "17px",
          src: require("../../assets/img/use.png")
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "info-name" }, [
      _c("span", [_vm._v("Net terms")]),
      _vm._v(" "),
      _c("span", { staticClass: "status color-green" }, [_vm._v("Active")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1aaf9836", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1aaf9836","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/components/head.vue
// module id = null
// module chunks = 